import { render, staticRenderFns } from "./FleetsTable.vue?vue&type=template&id=b128fb62&scoped=true&"
import script from "./FleetsTable.vue?vue&type=script&lang=js&"
export * from "./FleetsTable.vue?vue&type=script&lang=js&"
import style0 from "./FleetsTable.vue?vue&type=style&index=0&id=b128fb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b128fb62",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDataTable,VIcon,VSnackbar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b128fb62')) {
      api.createRecord('b128fb62', component.options)
    } else {
      api.reload('b128fb62', component.options)
    }
    module.hot.accept("./FleetsTable.vue?vue&type=template&id=b128fb62&scoped=true&", function () {
      api.rerender('b128fb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fleets/FleetsTable.vue"
export default component.exports